// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__2TNoq","menu_item":"Menu_menu_item__9hsCf"};